<script lang="ts">
  import ModalTemplate from '../../shared/ModalTemplate.svelte'
  import SmallPoem from '../SmallPoem.svelte'
  import {t} from '../../i18n'
  import type {Poem} from '../../types'
  import LoadMore from '../../shared/LoadMore.svelte'
  import {debounce} from '../../utils/debounce'
  import {modal} from '../../stores/modal'

  export let poem: Poem
  export let onSelected: (translation: Poem) => any

  let search: string = ''
  let debouncedSearch: string = ''

  const updateDebouncedSearch = debounce(() => debouncedSearch = search, 400)
  $: search && updateDebouncedSearch()

  let poems: Poem[] = []

  function selected(t: Poem): boolean {
    return poem.translated_poem_id === t.id
  }

  function selectPoem(t: any): void {
    if (!selected(t)) {
      onSelected(t)
      modal.close()
    }
  }
</script>

<ModalTemplate>
  <div class="modal-content">
    <input placeholder={t.poems.find} bind:value={search}/>

    <div class="translations-container">
      {#each poems as poem}
        <div onclick={() => selectPoem(poem)}>
          <SmallPoem {poem}/>
        </div>
      {/each}
    </div>

    {#if debouncedSearch}
      <LoadMore url="/poems" search={debouncedSearch} per={9} bind:items={poems}/>
    {/if}
  </div>
</ModalTemplate>

<style>
  .translations-container {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
  }

  .translations-container > div {
    width: 50%;
  }

  :global(.translations-container .grid__card:hover) {
    background: #eee;
    cursor: pointer;
  }
</style>